import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import GoBackButton from '@/common/components/GoBackButton'
import TextField from '@/common/components/TextField'
import { ChevronsRight } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'
import useBankInstitution from '../../hooks/useBankInstitution'

const Show = () => {
  const { id } = useParams();

  const {
    data: initialBankInstitution,
    isPending: initialBankInstitutionIsPending,
    error: initialBankInstitutionError = {} as any,
    refetch: refetchBankInstitution,
  } = useBankInstitution(id || '');

  const disableUpdateButton = initialBankInstitutionIsPending || initialBankInstitutionError?.status === 403;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/bank-institutions" searchLastRouteFromFallback />

          <p className="text-white-400 font-normal">
            Instituições bancárias
          </p>

          <ChevronsRight color="#ffffffb3" />

          <h2>{initialBankInstitution?.name}</h2>
        </div>

        <Link
          to={disableUpdateButton ? '' : `/bank-institutions/${id}/edit`}
          className={disableUpdateButton ? "cursor-default" : ''}
        >
          <Button operationKlassToCheckPermission="Admin::BankInstitutions::Update" data-testid="update_bank_institution_button" type="submit" className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]" disabled={disableUpdateButton}>
            Editar
          </Button>
        </Link>
      </div>

      {initialBankInstitutionIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={initialBankInstitutionError?.status}
          refetchFunction={refetchBankInstitution}
        >
          <Box className="flex max-h-[calc(100vh-128px)] flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)] overflow-y-auto">
            <p className="text-lg font-bold">Novo instituição bancária</p>

            <div className="flex gap-2">
              <TextField
                label="Código"
                name="code"
                className="w-1/2"
                value={String(initialBankInstitution?.code)}
                disabled
              />
              <TextField
                label="Nome"
                name="name"
                className="w-1/2"
                value={initialBankInstitution?.name}
                disabled
              />
            </div>
            <div className="flex gap-2">
              <TextField
                label="Regex de validação de conta"
                name="account_validation_regex"
                className="w-1/2"
                value={initialBankInstitution?.account_validation_regex}
                disabled
              />
              <TextField
                label="Regex de validação de filial"
                name="branch_validation_regex"
                className="w-1/2"
                value={initialBankInstitution?.branch_validation_regex}
                disabled
              />
            </div>
          </Box>
        </ErrorMessageWrapper>
      )}
    </div>
  )
}

export default Show
